import { useEffect, useState } from 'react';
import { getCountryInfo } from '../api/api';

export function useCountry(defaultCountry = 'US') {
  const [country, setCountry] = useState(defaultCountry);
  const [region, setRegion] = useState(null);
  const [flag, setFlag] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCountry = async () => {
      try {
        const data = await getCountryInfo(null, defaultCountry);

        if (isMounted && data?.success) {
          setCountry(data.country || defaultCountry);
          setRegion(data.region || null);
          setFlag(data.flag || null);
        }
      } catch (err) {
        if (isMounted) {
          setCountry(defaultCountry);
          setRegion(null);
          setFlag(null);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCountry();

    return () => {
      isMounted = false;
    };
  }, [defaultCountry]);

  return { country, region, flag, loading };
}
